module.exports = __webpack_public_path__ + "img/aplestore.14b2f0b2.png";